<template>
    <modal name="modalProgramGroupContributionIndefinite" :width="'40%'" :height="'auto'" :click-to-close="false">
        <form @submit.prevent="saveContribution">

            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title" v-if="prop_edit">Agregar Aportación </h5>
                <h5 class="modal-title" v-else>Información de Aportación </h5>
            </div>

            <div class="modal-body">
                <div>
                    <label>Origen del dinero</label>
                    <select class="form-control" :disabled="!prop_edit" v-model="form.source_key">
                        <option value="">Seleccione</option>
                        <option value="wallet">Desde monedero</option>
                        <option value="direct">Aportación directa</option>
                    </select>
                    <div v-if="errors.source_key" class="text-danger">{{ errors.source_key[0] }}</div>
                </div>
                <div class="mt-3" >
                    <label>Usuario</label>
                    <select class="form-control" :disabled="!prop_edit" v-model="form.user_id"  @change="onChangeUserCompany">
                        <option value="">Seleccione</option>
                        <option v-for="(user, index) in catalogue.users_programs"
                            :value="user.user_id + '|' + user.company_id" :key="index">
                            {{ user.name }} {{ user.last_name }} <span v-if="user.company"> - {{ user.company.name
                            }}</span>
                        </option>
                    </select>
                </div>

                <div class="mt-3" v-if="form.source_key === 'wallet'">
                    <label>Cuenta origen (monedero)</label>
                    <select class="form-control" :disabled="!prop_edit" v-model="form.bank_id"
                        @change="loadWallet()">
                        <option value="">Seleccione</option>
                        <option v-for="(acc, index) in catalogue.bank_accounts_companys" :key="index" :value="acc.id">
                                {{ acc.bank?.name || 'Banco' }} - {{ acc?.account_number || acc?.number || ('Cuenta #' +
                                acc?.id) }}
                            </option>
                    </select>
                    <div v-if="errors.bank_id" class="text-danger">
                        {{ errors.bank_id[0] }}
                    </div>

                    <div class="alert alert-success mt-3" v-if="form.bank_id">
                        <strong>Saldo en monedero:</strong> {{ wallet_balance | toCurrency }}
                    </div>
                </div>

                <div class="mt-3">
                    <label>Cuenta bancaria destino</label>
                    <select class="form-control" :disabled="!prop_edit" v-model="form.bank_account_company_id">
                        <option value="">Seleccione</option>
                        <option v-for="(account, index) in catalogue.bank_accounts_groups" :value="account.id"
                            :key="index">
                            {{ account.label }} 
                        </option>
                    </select>
                    <div v-if="errors.bank_account_company_id" class="text-danger">{{ errors.bank_account_company_id[0]
                    }}</div>
                </div>

                <div class="mt-3">
                    <label>Tipo de movimiento</label>
                    <select class="form-control" :disabled="!prop_edit" v-model="form.type_payments_id">
                        <option value="">Seleccione</option>
                        <!-- <option value="1">Depósito</option> -->
                        <option value="2">Transferencia</option>
                        <option value="5">Efectivo</option>
                    </select>
                    <div v-if="errors.type_payments_id" class="text-danger">{{ errors.type_payments_id[0] }}</div>
                </div>

                <div class="mt-3">
                    <label>Fecha</label>
                    <date-picker v-model="form.date" :disabled="!prop_edit" format="YYYY-MM-DD" valueType="format"></date-picker>
                    <div v-if="errors.date" class="text-danger">{{ errors.date[0] }}</div>
                </div>

                <div class="mt-3">
                    <label>Monto</label>
                    <input type="number" min="1" class="form-control" :disabled="!prop_edit" v-model="form.amount">
                    <div v-if="errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                </div>

                <div class="mt-3">
                    <label>Observaciones</label>
                    <textarea type="text" v-model="form.observation" class="form-control" :disabled="!prop_edit"></textarea>
                    <div v-if="errors.observation" class="text-danger">{{ errors.observation[0] }}</div>
                </div>

                <!-- Validación visual -->
                <div v-if="form.source_key === 'wallet' && Number(form.amount) > wallet_balance"
                    class="text-danger mt-1">
                    El monto excede el saldo disponible.
                </div>

                <div class="mt-4 mb-3">
                    <hr>
                    <button type="submit" class="btn btn-outline-success float-right" v-if="prop_edit"
                        :disabled="form.source_key === 'wallet' && Number(form.amount) > wallet_balance">
                        <i class="fas fa-save"></i> Guardar
                    </button>

                    <button type="button" class="btn btn-outline-warning float-left" @click="closeModal">
                        Cerrar
                    </button>
                    <br>
                </div>

            </div>

        </form>
    </modal>
</template>

<script>
import request from "@/services/request";
import { mapActions } from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Catalogue from '@/services/catalogue';

export default {       
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            wallet_balance: 0,
            form: {
                program_group_id: "",
                user_id: "",
                company_id: "",
                amount: "",
                source_key: "",
                aportacion_number: 0,
                type_payments_id: null,
                bank_account_company_id: "",
                bank_id: "",
                date: this.formatDate(new Date()),
                observation: ""
            },
            contribution_count: 0,            // aportaciones principales
            extra_contribution_count: 0,
            prop_edit: true
        };
    },

    methods: {
        async onChangeUserCompany() {
            this.errors = {};
            this.form.company_id = '';
            if (!this.form.user_id) return;
            let parts = this.form.user_id.split('|');
            this.catalogue.get_bank_accounts_companys(parts[1]);
        },
        formatDate(date) {
            return date.toISOString().split('T')[0];
        },
        closeModal() {
            this.errors = {};
            this.form = {
                program_group_id: "",
                user_id: "",
                company_id: "",
                amount: "",
                source_key: "",
                bank_account_company_id: "",
                bank_id: "",
                aportacion_number: null,
                observation: "",
            };
            this.contribution_count = 0;
            this.extra_contribution_count = 0;
            this.$modal.hide("modalProgramGroupContributionIndefinite");
        },

        async saveContribution() {
            let parts = this.form.user_id.split('|');

            let payload = {
                program_group_id: this.form.program_group_id,
                user_id: parts[0],
                company_id: parts[1],
                amount: this.form.amount,
                source_key: this.form.source_key,
                aportacion_number: this.form.aportacion_number,
                type_payments_id: this.form.type_payments_id,
                date: this.form.date,
                bank_account_company_id: this.form.bank_account_company_id,
                bank_id: this.form.bank_id,
                type_program: 2,
                observation: this.form.observation
            };
            try {
                let { data } = await request.post("/program-group-contributions", payload);
                this.successNotification(data.message);
                this.closeModal();
                Event.$emit("event-reload-program-relations");
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        async loadWallet() {
            if (!this.form.user_id || !this.form.bank_id) {
                this.wallet_balance = 0;
                return;
            }

            const [user_id, company_id] = this.form.user_id.split('|');
            let bank_id = this.form.bank_id;

            try {
                const { data } = await request.get(`/wallet/${user_id}/${company_id}/${bank_id}`);
                this.wallet_balance = Number(data.balance || 0);
            } catch (error) {
                console.log(error);
            }
        },

        async loadContributionSlots(program_id) {
            let url = `/programs/${program_id}/contribution-slots`;
            let { data } = await request.get(url);
            this.contributionSlots = data.slots;
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        })
    },

    created() {
        Event.$on("event-open-program-group-unidirectional-contribution", async (programa_group_id) => {
            this.prop_edit = true;
            // await this.catalogue.getBankAccountsCompanies(companies_id);
            await this.catalogue.get_bank_accounts_groups(programa_group_id);
            this.form.program_group_id = programa_group_id;
            this.$modal.show("modalProgramGroupContributionIndefinite");
        });
        Event.$on("event-show-program-group-contribution", async (contribution) => {
            await this.catalogue.get_bank_accounts_companys(contribution.company_id);
            this.form.source_key = contribution.source_id == 1 ? 'wallet' : 'direct';
            this.form.user_id = contribution.user_id+'|'+contribution.company_id;
            this.form.bank_id = contribution.bank_id;
            this.form.bank_account_company_id = contribution.bank_account_company_id;
            this.form.amount = contribution.amount;
            this.form.date = contribution.date;
            this.form.observation = contribution.observation;
            this.form.type_payments_id = contribution.type_payments_id;
            this.prop_edit = false;            
            this.$modal.show("modalProgramGroupContributionIndefinite");
        });
    },
    mounted() {
        this.catalogue.get_users_programs(this.$route.params.id);
    }
};
</script>

<style scoped>
.text-danger {
    font-size: 12px;
}

.alert-info {
    background: #e3f2fd;
}
</style>
